import React from 'react';
import { Line } from 'react-chartjs-2';
import './AdminCharts.css';
const AdminActivityChart = ({ history }) => {
  const chartData = {
    labels: history.map(item => item.date.substring(5)), // MM-DD
    datasets: [
      {
        label: 'Palabras Habladas',
        data: history.map(item => item.words_spoken),
        borderColor: '#4F46E5',
        backgroundColor: 'rgba(79, 70, 229, 0.1)',
        tension: 0.4,
        fill: true,
      },
      {
        label: 'Mensajes',
        data: history.map(item => item.messages),
        borderColor: '#10B981',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        tension: 0.4,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top', align: 'end', labels: { usePointStyle: true, boxWidth: 8 } },
    },
    scales: {
      y: { grid: { display: true, color: '#f1f5f9' }, ticks: { font: { size: 11 } } },
      x: { grid: { display: false }, ticks: { font: { size: 11 } } }
    }
  };

  return (
    <div className="ad-card ad-chart-section">
      <h2>📊 Actividad de Alumnos (7 Días)</h2>
      <div className="ad-chart-container">
        {history.length > 0 ? (
          <Line options={options} data={chartData} />
        ) : (
          <p className="ad-no-data">Sin datos recientes</p>
        )}
      </div>
    </div>
  );
};

export default AdminActivityChart;